<script setup lang="ts"></script>

<template>
  <div class="flex items-center mt-8">
    <h2 class="mr-auto text-lg font-medium">Error cargando módulo, actualiza presionando F5.</h2>
  </div>
</template>
